jPar.loginAndRegistration = jPar.loginAndRegistration || {};

$j(function () {
	try {
		jPar.Tracking.init();
	} catch (e) {
		jPar.util.log.error(e.stack, 'jPar.loginAndRegistration: Init external libs failed');
	}

	if (document.body.id === 'loginPage') {
		jPar.loginAndRegistration.loginPage.init();
	}

	if (document.body.id === 'verificationPage') {
		jPar.loginAndRegistration.verificationPage.init();
	}

	if (document.body.id === 'registrationPage') {
		jPar.loginAndRegistration.registrationPage.init();
	}

	if (document.body.id === 'passwordPage') {
		jPar.loginAndRegistration.passwordPage.init();
	}

	if (document.querySelector('#genderSelectionPage')) {
		if (document.body.classList.contains('isNewGenderScreenEnabled')) {
			jPar.loginAndRegistration.genderSelectPage.init();
		} else {
			jPar.loginAndRegistration.genderSelectPage_deprecated.init();
		}
	}

	if (document.querySelector('#searchGenderSelectionPage')) {
		jPar.loginAndRegistration.searchGenderSelectPage.init();
	}

	try {
		jPar.util.pwa.init();
		jPar.wdk.screensize.setScreenSizeCookie();
		jPar.util.timezone.setTimezone();
	} catch (e) {
		jPar.util.log.error(e.stack, 'jPar.loginAndRegistration: low prio failed');
	}
});
